/* eslint-disable */
export enum DURATION {
    d = 'Tag(e)',
    w = 'Woche(n)',
    m = 'Monat(e)',
    j = 'Jahr(e)'
}
